<script setup lang="ts">
import type { PropertyOnPage } from '@@/shared/property/api-types';

const props = defineProps<{
  property: PropertyOnPage
  title: string
}>();

const runtimeConfig = useRuntimeConfig();

const IMG_WIDTH = 390;
const photos = computed(() => {
  return props.property.photos
    .map((src) => {
      return getImageResize({
        src,
        width: IMG_WIDTH,
        resizeHostname: runtimeConfig.public.img.resizeHostname,
        factors: 4,
      });
    });
});
</script>

<template>
  <ul class="flex flex-col gap-xs flex-1">
    <li
      v-for="(photo, index) in photos"
      :key="photo.src"
    >
      <figure>
        <img
          v-bind="photo"
          :alt="`${title} — ${index + 1}/${photos.length}`"
          :width="String(IMG_WIDTH)"
          class="w-full"
        >
      </figure>
    </li>
  </ul>
</template>
